import { ModeratorPermissionsResponse } from "../api/moderators";

export enum UserRole {
  SUPERADMIN = "superadmin",
  ADMIN = "admin",
  MODERATOR = "moderator",
  USER = "user",
}

export type UserContextRole = {
  type: UserRole;
  permissions: ModeratorPermissionsResponse;
};

export const isAdminRole = (role: UserRole | undefined) => {
  return role === UserRole.SUPERADMIN || role === UserRole.ADMIN;
};
